'use strict';

(function () {
  var fileUpload = document.querySelectorAll('.gfield.file-upload');

  if (!fileUpload.length) {
    return;
  }

  fileUpload.forEach(function (el, i) {
    var uploadLabel = el.querySelector('.gfield_label');
    var uploadInput = el.querySelector('input[type="file"]');

    uploadInput.addEventListener('change', function () {
      var filePath = this.value;
      var fileName = filePath.substr(filePath.lastIndexOf('\\') + 1);

      uploadLabel.innerHTML = fileName;
    });

    // Prevent Duplicate ID from Temporary field
    var inputId = el.id.replace('field_', '');
    var validationMsg = document.querySelectorAll('#validation_message_' + inputId);
    var tempMsg = document.querySelector('.temp_validation_' + inputId);

    if (tempMsg && validationMsg.length > 1) {
      tempMsg.parentNode.removeChild(tempMsg);
    }
  });
})();